import { useCallback } from 'react'
import { InputTableLeftColumnChange } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { SetCompleteDataTy } from '../OrderLayout/types'
import { twinFetchPostText } from '../../../../utils/globals/data'

interface useOrderITHeaderHandleChangeLogicProps {
    updateDataURL: string
    setCompleteData: SetCompleteDataTy
}

export const useOrderITHeaderHandleChangeLogic = ({ setCompleteData, updateDataURL }: useOrderITHeaderHandleChangeLogicProps) => {
    const handleChange: InputTableLeftColumnChange = useCallback(async (id, field, value) => {
        setCompleteData((old) => {
            if (!old) {
                return null
            }
            old.header[field] = value
            return { ...old }
        })
        await twinFetchPostText(updateDataURL, { id, [field]: value })
    }, [updateDataURL, setCompleteData])
    
    return { handleChange }
}